import { useRef } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { MovieCard, MovieCardSkeleton } from "./MovieCard";
import { ErrorState } from "./ErrorState";

export const MovieRow = ({ title, eyebrow, movies, loading, error, onRetry, id }) => {
  const ref = useRef(null);
  const scroll = (dir) => ref.current?.scrollBy({ left: dir * ref.current.clientWidth * 0.85, behavior: "smooth" });

  return (
    <section data-testid={`row-${id}`} className="relative py-8 md:py-10">
      <div className="mx-auto flex max-w-7xl items-end justify-between px-5 md:px-10">
        <div>
          {eyebrow && <p className="eyebrow mb-2 text-[#D4AF37]">{eyebrow}</p>}
          <h2 className="font-display text-2xl font-semibold text-white md:text-3xl">{title}</h2>
        </div>
        <div className="hidden gap-2 md:flex">
          {[-1, 1].map((d) => (
            <button
              key={d}
              type="button"
              onClick={() => scroll(d)}
              data-testid={`row-${id}-${d < 0 ? "prev" : "next"}-btn`}
              aria-label={d < 0 ? "Scroll left" : "Scroll right"}
              className="grid h-10 w-10 place-items-center rounded-full border border-white/15 text-neutral-300 transition-colors duration-300 hover:border-[#D4AF37] hover:text-[#D4AF37]"
            >
              {d < 0 ? <ChevronLeft className="h-5 w-5" /> : <ChevronRight className="h-5 w-5" />}
            </button>
          ))}
        </div>
      </div>
      {error ? (
        <div className="mx-auto mt-6 max-w-7xl px-5 md:px-10">
          <ErrorState message={error} onRetry={onRetry} testId={`row-${id}-error`} />
        </div>
      ) : (
        <div ref={ref} className="no-scrollbar mx-auto mt-6 flex max-w-7xl snap-x snap-mandatory scroll-px-5 gap-4 overflow-x-auto px-5 pb-2 md:scroll-px-10 md:gap-5 md:px-10">
          {(loading ? Array.from({ length: 8 }) : movies || []).map((m, i) => (
            <div key={m?.id ?? i} className="w-[42%] shrink-0 snap-start sm:w-[28%] md:w-[20%] lg:w-[15.5%]">
              {loading ? <MovieCardSkeleton /> : <MovieCard movie={m} testPrefix={`${id}-card`} />}
            </div>
          ))}
        </div>
      )}
    </section>
  );
};
